<template>
  <v-row justify="center">
    <v-col cols="12" md="9">

      <!-- Header -->
      <v-card outlined class="mb-4">
        <v-card-text class="pb-3">
          <div class="d-flex align-start justify-space-between">
            <div>
              <div class="text-h5 font-weight-bold">{{ sucursalSeleccionada.nombre }}</div>
              <div class="text-subtitle-2 grey--text mt-1">
                {{ sucursalSeleccionada.empresa.razonSocial }}
              </div>
            </div>
            <v-chip v-if="sucursalSeleccionada.condicionIva" color="primary" small>
              {{ sucursalSeleccionada.condicionIva.nombre }}
            </v-chip>
            <v-chip v-else outlined x-small color="warning">Sin condición IVA</v-chip>
          </div>
        </v-card-text>
      </v-card>

      <v-row>
        <!-- Ubicación -->
        <v-col cols="12" md="6">
          <v-card outlined height="100%">
            <v-card-title class="text-subtitle-2 pb-1">Ubicación</v-card-title>
            <v-divider></v-divider>
            <v-list dense>
              <v-list-item>
                <v-list-item-icon><v-icon small>mdi-map-marker</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>Dirección</v-list-item-subtitle>
                  <v-list-item-title>{{ sucursalSeleccionada.direccion || '—' }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon><v-icon small>mdi-city</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>Localidad</v-list-item-subtitle>
                  <v-list-item-title>
                    {{ sucursalSeleccionada.localidad ? sucursalSeleccionada.localidad.nombre : '—' }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon><v-icon small>mdi-map</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>Provincia</v-list-item-subtitle>
                  <v-list-item-title>
                    {{ sucursalSeleccionada.localidad && sucursalSeleccionada.localidad.provincia
                      ? sucursalSeleccionada.localidad.provincia.nombre
                      : '—' }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>

        <!-- Contacto y red -->
        <v-col cols="12" md="6">
          <v-card outlined height="100%">
            <v-card-title class="text-subtitle-2 pb-1">Contacto y red</v-card-title>
            <v-divider></v-divider>
            <v-list dense>
              <v-list-item>
                <v-list-item-icon><v-icon small>mdi-phone</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>Teléfono</v-list-item-subtitle>
                  <v-list-item-title>{{ sucursalSeleccionada.telefono || '—' }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon><v-icon small>mdi-lan</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>IP address</v-list-item-subtitle>
                  <v-list-item-title>{{ sucursalSeleccionada.ip_address || '—' }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon><v-icon small>mdi-send</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>Telegram chat ID</v-list-item-subtitle>
                  <v-list-item-title>{{ sucursalSeleccionada.telegram_chat_id || '—' }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>
      </v-row>

    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: "SucursalDetallesGenerales",
  computed: {
    ...mapGetters("admin", ["sucursalSeleccionada"]),
  },
};
</script>
